import { Drawer, Modal } from "antd";
import styled from "styled-components";

// Formulario de usuarios / domiciliarios (panel lateral)
export const WrapperDrawerUsers = styled(Drawer)`
  .ant-drawer-header {
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 20px;
  }
  .ant-drawer-title {
    font-weight: 600;
    font-size: 16px;
  }
  .ant-drawer-body {
    padding: 12px 20px 24px;
  }
  .ant-drawer-close {
    margin-inline-end: 0;
  }
`;

// ModalUsers legacy name kept for other modals if needed
export const WrapperModalUsers = styled(Modal)`
  & .ant-modal-content {
    border-radius: 16px;
  }

  & .ant-modal-header {
    border-radius: 16px 16px 0 0;
  }

  & .ant-modal-footer {
    display: none;
  }
`;

export const WrapperModalWarehouses = styled(Drawer)`
  /* min-height: 100vh;
  padding: 0;
  display: flex;
  width: 100vw;
  position: absolute;
  top: 0;
  right: 0;
  width: 25vw;

  & .ant-modal-content {
    width: 100%;
  }

  & .ant-modal-body {
  }

  & .ant-modal-footer {
    display: none;
  }

  @media (max-width: 767px) {
    margin: 0;
  } */
`;

export const WrapperModalOrderShipped = styled(Modal)`
  /* min-height: 100vh;
  padding: 0;
  display: flex;
  width: 100vw;
  position: absolute;
  top: 0;
  right: 0;
  width: 25vw; */

  & .ant-modal-content {
    width: 100%;
  }

  & .ant-modal-body {
  }

  & .ant-modal-footer {
    display: none;
  }
`;


export const WrapperModalProductWarehouses = styled(Modal)`
  /* min-height: 100vh;
  padding: 0;
  display: flex;
  width: 100vw;
  position: absolute;
  top: 0;
  right: 0;
  width: 25vw; */

  & .ant-modal-content {
    width: 100%;
  }

  & .ant-modal-body {
  }

  & .ant-modal-footer {
    display: none;
  }
`;
